<template>
    <div v-if="isLoaded && isHaveItem">
        <div class="title">{{ lbl.home.buy_again }}</div>
        <div class="buy-again-slide">
            <div class="splide" id="buy_again_slide">
                <div class="splide__track">
                    <ul class="splide__list">
                        <li class="splide__slide"
                            v-for="(campaign, k) in campaigns" :key="k">
                            <BuyAgainItem
                                :key="k"
                                :index="k"
                                :campaign="campaign"
                            ></BuyAgainItem>
                        </li>
                    </ul>
                </div>
            </div>

            <!-- <div class="voucher-pagination-prev">
                <button class="bg-yellow-400 p-2 mr-4" @click="btnPrev()">Prev</button>
            </div> -->
            <div class="buy-again-pagination-next" v-if="campaigns.length > 6">
                <img @click="btnNext()" src="@/assets/new/icon/ic-pagination-next.png"/>
            </div>
        </div>
    </div>
</template>
<script>
import Splide from '@splidejs/splide'; //https://splidejs.com/
//mixin
import AccountMixin from '@/mixin/AccountMixin.js';
import LocaleMixin from '@/mixin/LocaleMixin.js';
import ErrorApiMixin from '@/mixin/ErrorApiMixin.js';
//component
import BuyAgainItem from './BuyAgainItem.vue';
//service
import HomeService from '../../service/HomeService.js';

export default {
    name: 'BuyAgainSlider',
    mixins: [AccountMixin, LocaleMixin, ErrorApiMixin],
    components: {
        BuyAgainItem,
    },
    data: function () {
        return {
            isLoaded: false,
            isHaveItem: false,
            campaigns: [],
            slider: null,
            currentSliderIndex: 0,
        };
    },
    methods: {
        accountInitiated: function(){
            this.getBuyAgainList();
        },
        getBuyAgainList: function(){
            var token = this.getToken();

            HomeService.apiGetBuyAgain(token).subscribe((res) =>{
                console.log('buy', res);

                for (var campaign of res) {
                    this.campaigns.push(campaign);
                }

                this.isLoaded = true;
                this.isHaveItem = this.campaigns.length > 0
                    ? true
                    : false;

                this.setSlider()

            }, (err) =>{
                this.isLoaded = false;
                this.isHaveItem = false;
                console.log(err);
                this.errorApi(err);
            })
        },
        setSlider: function() {
            this.$nextTick(() => {
                this.slider = new Splide('#buy_again_slide', {
                    type : 'slide',
                    autoWidth: true,
                    pagination : false,
                    arrows: false,
                    gap: 24,
                }).mount()

                this.slider.on('move', (newIndex) => {
                    this.currentSliderIndex = newIndex
                })
            })

            console.log('this.currentSliderIndex', this.currentSliderIndex)
        },
        btnNext: function() {
            let next = this.currentSliderIndex + 1
            this.slider.go(next)
        },
        btnPrev: function() {
            let prev = this.currentSliderIndex - 1
            this.slider.go(prev)
        },
    }
}
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
.title{
    font-family: $ff-medium;
    font-size: 1rem;
    color: $a-black-333333;
}

// #buy_again_slide-list{
//     gap: 1rem;
// }
.buy-again-slide {
    position: relative;

    .voucher-pagination-prev {
        position: absolute;
        top: 30px;
        left: -30px;
        width: 100%;
    }
    .buy-again-pagination-next {
        position: absolute;
        top: 35%;
        right: -30px;
    }
}
</style>
